export default [
  {
    path: "/remote-development-env/:ideConfigCrdName/:namespace/:domainURL/vscode",
    beforeEnter: (to) => {
      const ideConfigCrdName = to.params.ideConfigCrdName;
      const domainURL = to.params.domainURL;
      const namespace = to.params.namespace;

      window.open(
        `https://${domainURL}/${ideConfigCrdName}/${namespace}/vscode`,
        "_blank",
      );
    },
  },
  {
    path: "/remote-development-env/:ideConfigCrdName/:namespace/:domainURL/ssh",
    beforeEnter: (to) => {
      const ideConfigCrdName = to.params.ideConfigCrdName;
      const domainURL = to.params.domainURL;
      const namespace = to.params.namespace;

      window.open(
        `https://${domainURL}/${ideConfigCrdName}/${namespace}/cli`,
        "_blank",
      );
    },
    // component: () =>
    //   import("../pages/workspace/RemoteDevelopmentEnvSshPage.vue"),
  },
  {
    path: "/remote-development-env/:ideConfigCrdName/:namespace/:domainURL/notebook",
    beforeEnter: (to) => {
      const ideConfigCrdName = to.params.ideConfigCrdName;
      const domainURL = to.params.domainURL;
      const namespace = to.params.namespace;

      window.open(
        `https://${domainURL}/${ideConfigCrdName}/${namespace}/jupyter`,
        "_blank",
      );
    },
    // component: () =>
    //   import("../pages/workspace/RemoteDevelopmentEnvSshPage.vue"),
  },
];
